import styled from "styled-components";

import { COLORS } from "@/react/theme/constants";

export const CustomerCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const TopContainer = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 12px 20px;
  border: 1px solid ${COLORS.tertiary};
`;

export const BottomContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border: 1px solid ${COLORS.tertiary};
  border-top: none;
`;

export const DropdownWrapper = styled.div`
  margin-left: 8px;
  min-width: 250px;
`;

export const SelectorLabel = styled.span`
  font-weight: bold;
`;
